import React from 'react';
import { downloadFile } from 'components/util/file_util';
import l from "components/util/l";
import { FilePreview } from 'components/util/helpers/FilePreview';

const FileViewer = ({ 
  file 
}) => {
  return (<div className='card'>
    <div class="card-header">
      <h3 class="mb-0">{l("Descargar archivo%CA072")}</h3>
    </div>
    <div class="card-body py-4">
      <FilePreview file={file} />
      <button
        type="button"
        className='btn btn-primary w-100'
        onClick={() => {
          downloadFile(file.url, null, file.name.includes('_') ? file.name.split('_').slice(1).join('_') : file.name);
        }}
      >
        {l("Descargar%GA027")}
      </button>
    </div>
  </div>)

}

export default FileViewer;